import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["blocks", "breadcrumbs", "callbackRequestData", "pageSettings", "selfCallingPopupData", "userData"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// import deepmerge from 'deepmerge';

import { FttbBlocks } from "./blocks/constants";

/**
 * Все добавляемые моки должны быть прикреплены к задаче на бэке.
 *   После исполнения задачи - моки должны быть выброшены. В идеале эта секция должна быть закомментирована
 */

// const overrideData = (backendData, mockData) => deepmerge(mockData, backendData, {
//   arrayMerge: (_, incoming) => incoming,
// });
// const overrideBy = (blocks, field, mocks) => blocks.map((block) => overrideData(block, mocks[block[field]]));

var getBlockByAlias = function getBlockByAlias(blocks, alias) {
  return blocks.find(function (block) {
    return block.alias === alias;
  });
};
export var convertFTTB2022CatalogPageData = function convertFTTB2022CatalogPageData(_ref) {
  var _tariffsBlock$data$ta;
  var blocks = _ref.blocks,
    breadcrumbs = _ref.breadcrumbs,
    callbackRequestData = _ref.callbackRequestData,
    pageSettings = _ref.pageSettings,
    selfCallingPopupData = _ref.selfCallingPopupData,
    userData = _ref.userData,
    data = _objectWithoutProperties(_ref, _excluded);
  var tariffsBlock = getBlockByAlias(blocks, FttbBlocks.TARIFFS);
  return {
    content: _objectSpread(_objectSpread({}, data), {}, {
      blocks: blocks
    }),
    modules: {
      tariffs: {
        group: tariffsBlock === null || tariffsBlock === void 0 || (_tariffsBlock$data$ta = tariffsBlock.data.tabsSettings) === null || _tariffsBlock$data$ta === void 0 ? void 0 : _tariffsBlock$data$ta.selectedTab
      }
    },
    shared: {
      breadcrumbs: breadcrumbs,
      callbackRequestData: callbackRequestData,
      pageSettings: pageSettings,
      paymentMethods: ['fps', 'card', 'sberpay', 'savedCards'],
      selfCallingPopupData: selfCallingPopupData,
      userData: userData
    }
    // Ниже пример переопределения для блоков
    // content: overrideData(data, {
    // Секция переопределения данных конкретных блоков, после удаления, не забываем прокинуть blocks :)
    // blocks: overrideBy(blocks, 'alias', {
    // [FttbBlocks.CHECK_ADDRESS]: {
    //   data: {},
    //   content: {
    //     // Add default value for your field here
    //   },
    // },
    // }),
    // }),
  };
};